import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { toast } from "sonner";
import { Tornado } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(email, password);
      toast.success("Welcome back!");
      const to = location.state?.from?.pathname || (user.role === "admin" ? "/admin" : "/account");
      navigate(to, { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
      <div className="text-center mb-8">
        <Tornado className="w-10 h-10 text-[#D35400] mx-auto mb-3" strokeWidth={2.5} />
        <h1 className="font-display text-6xl">Sign In</h1>
        <p className="text-[#4A4A4A] mt-2">Welcome back to the Alley.</p>
      </div>
      <form onSubmit={submit} className="border-2 border-[#1C1C1C] hard-shadow bg-[#F5F2EA] p-8 space-y-5" data-testid="login-form">
        <div>
          <label className="font-display text-xl">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="login-email" />
        </div>
        <div>
          <label className="font-display text-xl">Password</label>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full mt-1 px-4 py-3 border-2 border-[#1C1C1C] bg-white focus:outline-none focus:border-[#D35400]" data-testid="login-password" />
        </div>
        <button type="submit" disabled={loading} className="btn-primary w-full px-8 py-4 disabled:opacity-60" data-testid="login-submit">
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <p className="text-center text-sm">
          No account?{" "}
          <Link to="/register" className="font-bold underline underline-offset-4 text-[#D35400]" data-testid="go-register">Create one</Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
